<template>
    <div class="assessment-container">
        <el-row>
            <el-col :span="isGeneralAdmin || hasFilter ? 12 : 24">
                <organization-breadcrumb :items="[$t('study_sets.curriculum'), 'assessments']" />
            </el-col>
            <el-col v-if="isGeneralAdmin || hasFilter" :span="12">
                <admin-organization-switcher/>
            </el-col>
        </el-row>
        <div class="content">
            <curriculum-menu :active-entry="`/organization/${currentOrganizationId}/assessments`" />
            <div class="table-wrapper">
                <el-table
                    ref="multipleTable"
                    :data="AssessmentList"
                    :empty-text="$t('common.no_values')"
                >
                    <el-table-column
                        prop="assessment_name"
                        sort-by="assessment_name"
                        sortable
                        :label="$t('homework.assessment.table.name_label')"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.name }}
                        </template>
                    </el-table-column>
                    <el-table-column v-if="this.isOrganizationAdmin || isOrganizationTeacher" align="right" width="250">
                        <template slot-scope="scope">
                            <div class="flex justify-end">
                                <span class="assign-to-class" @click="handleAssignToClass(scope.row)">
                                    <chip>{{$t('study_sets.assign_to_class')}}</chip>
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <add-assignment-wrapper ref="addAssignmentWrapper" />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import OrganizationBreadcrumb from "@/components/common/OrganizationBreadcrumb";
import AdminOrganizationSwitcher from "@/components/dashboard/AdminOrganizationSwitcher";
import CurriculumMenu from '@/components/studysets/CurriculumMenu';
import Chip from '@/components/common/Chip';
import AddAssignmentWrapper from "@/components/modals/studysets/AddAssignmentWrapper";

export default {
  components: {
    OrganizationBreadcrumb,
    AdminOrganizationSwitcher,
    CurriculumMenu,
    Chip,
    AddAssignmentWrapper,
  },
  props: {
  },
  data() {
    return {
      AssessmentList: [
        {id: 'general', name: 'General ELSA members assessment test'}
      ],
    };
  },
  computed: {
    ...mapGetters(
      'organization', [
        'isGeneralAdmin',
        'hasFilter',
        'currentOrganizationType',
        'currentOrganizationId',
        'isOrganizationAdmin',
        'isOrganizationTeacher'
      ]
    ),
  },
  methods: {
    handleAssignToClass(assessment) {
      this.$refs.addAssignmentWrapper.handleAssignAssessmentToClass(assessment);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/_colors.scss';
.assessment-container {
    width: 100%;
  .content {
    margin: 24px 40px;
    .assign-to-class {
        margin-right: 8px;

        button {
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
          padding: 8px 16px;
          border: 1px solid #007eff;
        }
    }
  }
}
</style>
